export enum DeepLinkType {
  Group = 'group',
  StickerPack = 'sticker.pack',
  Message = 'message',
  User = 'user',
  SpaceLocal = 'space.local',
  Call = 'call',
  CallMe = 'callMe',
  Card = 'card',
  Room = 'room',
  MiniApp = 'miniapp',
  Unknown = 'unknown',
  Screen = 'screen',
}

export enum DeepLinkScreenType {
  Chats = 'chatsPage',
  Contacts = 'contactsPage',
  NewMessage = 'newMessagePage',
  Spaces = 'spacesPage',
  Channels = 'channelsPage',
  Catalog = 'catalogPage',
  Bots = 'botsPage',
  StartNewCall = 'startNewCallPage',
  CreateNewSpace = 'createNewSpacePage',
  Paywall = 'paywall',
}

export interface IDeepLinkTargetUrls {
  desktopUrl?: string;
  androidUrl?: string;
  iosUrl?: string;
}

export interface IGetDeepLinkRequest {
  url: string;
}

export interface IDeepLink {
  type: DeepLinkType;
  entityId: string;
  channelId?: string;
  entityIdStr?: string;
  parentId?: string;
  parentIdStr?: string;
  url?: string;
  alias?: string;
  expired: boolean;
  title?: string;
  description?: string;
  imageUrl?: string;
  targetUrls?: IDeepLinkTargetUrls;
}

export interface IDeepLinkInfoResponse {
  deepLink: string;
  deepLinkAlias: string;
  deepLinkQrUrl?: string;
}
